import React, { useContext } from "react";
import { Button } from "semantic-ui-react";
import { RootStoreContext } from "../../../../app/stores/rootStore";

interface IProps {
  id: string;
}
const DeleteCertificate: React.FC<IProps> = ({ id }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { closeModal } = rootStore.modalStore;
  const { delCertificate } = rootStore.certificateStore;

  return (
    <div className="modalContent">
      <label>¿Esta seguro que desea eliminar el certificado?</label>
      <br />
      <br />
      <Button color="red" inverted onClick={() => closeModal()}>No</Button>
      <Button
        positive
        onClick={() => delCertificate(id)}
        icon="checkmark"
        content="Si"
      />
    </div>
  );
};
export default DeleteCertificate;
